import React from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

export default function Layout({ children, hero = false }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header showHeroSearch={hero} />
      <main className="flex-1">
        <div className="max-w-[1280px] mx-auto px-4 lg:px-6 py-6">
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
}
